<template>
  <div class="component-wrap">
    <div class="countdown-wrap">
      <van-countdown
        class="countdown"
        ref="countdown"
        @timeout="timeout"
        v-if="!isExam"
        :seconds="countdownTimes" />
    </div>
    <component
      :key="exercise.code"
      :id="exercise.id"
      :is="quizzes[exercise.code]"
      :exercise="exercise"
      :is-show-explain="isShowExplain"
      :is-done="isDone"
      :is-random="isRandomOption"
      :is-show-hint="!isExam && quizType === 'learn'"
      :mode="exercise.mode"
      :action="'/api/home/student/play/template/get/audioDiscern'"
      auth-action="/api/home/student/user/get/xunfeiWsAuth"
      :is-exam="isExam"
      :is-directly-complete="false"
      :user-answer="userAnswer"
      @error="audioError"
      @played="played"
      @complete="complete"
      @skip="skip"
      @switch="isShowExplain = !isShowExplain"
      @change="change">
    </component>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import VanCountdown from '@/components/common/Countdown.vue';
import CHXZ from 'vanthink-components/components/quiz/CHXZ/CHXZ-U.vue';
import DCTX from 'vanthink-components/components/quiz/DCTX/DCTX-U.vue';
import SK from 'vanthink-components/components/quiz/SK/SK-U.vue';
import HYDC from 'vanthink-components/components/quiz/HYDC/HYDC-U.vue';
import DCPX from 'vanthink-components/components/quiz/DCPX/DCPX-U.vue';
import QHLJ from 'vanthink-components/components/quiz/QHLJ/QHLJ-U.vue';
import utils from '@/services/utils';

// 默认添加的游戏型号
const DEFAULT_SK_GAME = {
  code: 'SK',
  mode: 2,
};
// const DEFAULT_HYDC_GAME = {
//   code: 'HYDC',
//   mode: 2,
// };
const DEFAULT_DCTX_GAME = {
  code: 'DCTX',
  mode: 1,
};

const DEFAULT_DCPX_GAME = {
  code: 'DCPX',
  mode: 1,
};

export default {
  components: {
    VanCountdown,
  },
  props: {
    exercises: {
      type: Array,
      required: true,
    },
    examResults: {
      type: Array,
      default: () => [],
    },
    userAnswer: {
      type: [Array, String, Object, Number],
      default: null,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    quizType: {
      type: String,
      default: 'learn',
    },
    bookMode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newExercises: [],
      results: [],
      spend: [],
      examSpend: [],
      exerciseIndex: 0,
      isDone: false,
      isShowExplain: true,
      isRight: false,
      seconds: 0,
      autoNext: true,
      timer: null,
      delay: null,
      isPlayed: false,
      quizzes: {
        CHXZ,
        DCTX,
        SK,
        HYDC,
        DCPX,
        QHLJ,
      },
    };
  },
  watch: {
    exercise: {
      handler() {
        const isOutputAnswer = utils.storage('frontend_nb');
        if (isOutputAnswer) {
          this.outputAnswer();
        }
        this.time();
        this.autoNext = true;
        if (this.delay) {
          clearTimeout(this.delay);
          this.delay = null;
        }
        // 游戏需要音频播放完进入下一题,不需要的游戏默认为true
        if (this.exercise.code !== 'CHXZ' && this.exercise.code !== 'DCPX') {
          this.isPlayed = true;
        } else {
          this.isPlayed = false;
        }
        if (this.exercise
          && this.exercise.code === 'SK') {
          this.isRight = true;
          this.isDone = true;
        } else if (this.exercise && this.exercise.code === 'CHXZ' && !this.isExam) {
          this.isRight = false;
          this.isDone = true;
        } else {
          this.isRight = false;
          this.isDone = false;
        }
        this.$nextTick(() => {
          if (!this.isExam && this.newExercises.length) {
            this.$refs.countdown.start(true);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    exercises: {
      handler() {
        if (this.isExam || this.quizType === 'level') {
          this.initNewExercises();
        }
      },
      deep: true,
    },
    exerciseIndex() {
      this.$emit('exercise-change', { exerciseIndex: this.exerciseIndex, id: this.exercise.id });
    },
    newExercises() {
      if (this.newExercises.length === 0 && !this.isExam) {
        this.$emit('finish', {
          results: this.results,
          spend: this.spend,
          isHalf: false,
        });
      }
    },
    isDone() {
      if (this.isDone) {
        this.$refs.countdown.stop();
      }
    },
  },
  computed: {
    exercise() {
      return this.newExercises[this.exerciseIndex] || {};
    },
    isDirectlyDone() {
      return this.exercise.code === 'SK' && this.exercise.mode === 3;
    },
    isRandomOption() {
      return this.exercise.code === 'CHXZ' && !this.isExam;
    },
    countdownTimes() {
      return this.bookMode === 'basic' ? 10 : 15;
    },
  },
  created() {
    this.initNewExercises();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.delay);
  },
  methods: {
    initNewExercises() {
      this.newExercises = utils.clone(this.exercises);
      this.newExercises.forEach((item) => {
        item.showCount = 0;
      });
      this.results = [];
      this.examSpend = this.newExercises.map(item => ({
        code: item.code,
        mode: item.mode,
        spendTime: 0,
      }));

      if (this.bookMode === 'basic' && this.quizType === 'learn') {
        const first = this.newExercises.filter(item => item.code === 'CHXZ' && item.mode === 1);
        const second = this.newExercises.filter(item => item.code === 'CHXZ' && item.mode === 2);
        const length = first.length > second.length ? first.length : second.length;
        this.newExercises = this.newExercises.filter(item => !(item.code === 'CHXZ' && (item.mode === 1 || item.mode === 2)));
        for (let i = 0; i < length; i += 1) {
          if (first[i]) {
            this.newExercises.push(first[i]);
          }
          if (second[i]) {
            this.newExercises.push(second[i]);
          }
        }
      }
    },
    audioError({ message }) {
      utils.error(message);
    },
    outputAnswer() {
      const {
        text,
        explain,
      } = this.exercise;
      if (text && explain) {
        console.log('%c word =>', 'background: green; color:#fff;', text);
        console.log('%c explain =>', 'background: blue; color:#fff;', explain);
      }
    },
    time() {
      this.seconds = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.seconds += 1;
        if (this.isExam) {
          if (this.examSpend[this.exerciseIndex]) {
            this.examSpend[this.exerciseIndex].spendTime += 1;
          }
        }
      }, 1000);
    },
    timeout() {
      clearTimeout(this.delay);
      this.isDone = true;
      this.delay = null;
      this.autoNext = true;
      this.isPlayed = true;
      if (this.exercise.code === 'DCPX' && this.exercise.mode === 4) {
        this.skip();
      } else {
        this.next();
      }
    },
    handlerAutoNext() {
      if (this.delay) return;
      if (this.exercise.code === 'CHXZ' && this.exercise.mode !== 2 && this.isRight) {
        this.autoNext = false;
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.autoNext = true;
          this.next();
          clearTimeout(this.delay);
          this.delay = null;
        }, 1000);
      }
    },
    played() {
      this.isPlayed = true;
      if (this.delay) return;
      if (this.autoNext && !this.isExam) {
        if (((this.exercise.code === 'CHXZ' && this.exercise.mode === 2)
          || this.exercise.code === 'DCPX') && this.isRight) {
          this.autoNext = false;
          clearTimeout(this.delay);
          this.delay = setTimeout(() => {
            this.autoNext = true;
            this.next();
            clearTimeout(this.delay);
            this.delay = null;
          }, 200);
        }
      }
    },
    complete() {
      if (this.delay) return;
      if (this.isExam) return;
      if (this.autoNext) {
        const { code } = this.exercise;
        if (code !== 'QHLJ' && code !== 'SK' && code !== 'CHXZ' && this.isRight) {
          this.autoNext = false;
          clearTimeout(this.delay);
          this.delay = setTimeout(() => {
            this.autoNext = true;
            this.next();
            clearTimeout(this.delay);
            this.delay = null;
          }, 1000);
        }
      }
      this.next();
    },
    change(payload) {
      this.$nextTick(() => {
        if (!this.isExam && this.exercise.code !== 'CHXZ') {
          this.$refs.countdown.start();
        }
        if (this.exercise.code !== 'SK') {
          this.isRight = payload.isRight;
          const exercise = {
            ...this.exercise,
            isRight: payload.isRight,
            userAnswer: payload.answer,
            isComplete: payload.isComplete,
          };
          if (payload.isComplete && !payload.isRight && this.exercise.code === 'CHXZ' && !this.isExam) {
            this.$refs.countdown.stop();
          }
          this.$emit('change', exercise);
        }
        if (this.autoNext && !this.isExam) {
          this.handlerAutoNext();
        }
      });
    },
    skip() {
      this.exercise.errorCount += 1;
      this.pushResults();
      if (this.exercise.errorCount === 4) {
        const newExercise = utils.clone(this.exercise);
        newExercise.code = DEFAULT_SK_GAME.code;
        newExercise.mode = DEFAULT_SK_GAME.mode;
        this.newExercises.splice(1, 0, newExercise);
        this.removeNewExercise();
      } else {
        const newExercise1 = utils.clone(this.exercise);
        newExercise1.code = DEFAULT_DCPX_GAME.code;
        newExercise1.mode = DEFAULT_DCPX_GAME.mode;
        newExercise1.isClone = true;
        const newExercise2 = utils.clone(this.exercise);
        newExercise2.code = DEFAULT_DCTX_GAME.code;
        newExercise2.mode = DEFAULT_DCTX_GAME.mode;
        newExercise2.isClone = true;
        this.newExercises.splice(1, 0, newExercise2, newExercise1);
        this.backwardsInsertExercise(null, 3);
      }
    },
    correctExercise() {
      /* eslint-disable no-lonely-if */
      this.exercise.spendTime += this.seconds;
      this.exercise.showCount += 1;

      if (this.isRight) {
        if (this.exercise.isScoring) {
          this.$emit('scoring', {
            quizzes: [
              {
                id: this.exercise.id,
                code: this.exercise.code,
                mode: this.exercise.mode,
              },
            ],
          });
        }
        this.pushResults();
        this.removeNewExercise();
      } else {
        this.exercise.errorCount += 1;
        this.pushResults();

        if (this.quizType === 'level') {
          this.removeNewExercise();
          return;
        }
        if (this.exercise.code === 'DCPX' && (this.exercise.mode === 4 || this.exercise.mode === 2) && this.exercise.errorCount === 4) {
          const newExercise = utils.clone(this.exercise);
          newExercise.code = DEFAULT_SK_GAME.code;
          newExercise.mode = DEFAULT_SK_GAME.mode;
          newExercise.isClone = true;
          this.newExercises.splice(0, 1, newExercise);
        } else if (this.exercise.errorCount >= 5 && this.bookMode !== 'basic') {
          this.removeNewExercise();
        } else if (this.exercise.code === 'DCPX' && this.exercise.mode === 4) {
          const newExercise = utils.clone(this.exercise);
          newExercise.code = DEFAULT_DCPX_GAME.code;
          newExercise.mode = DEFAULT_DCPX_GAME.mode;
          newExercise.isClone = true;
          this.newExercises.splice(1, 0, newExercise);
          this.backwardsInsertExercise(null, 2);
        } else if (this.exercise.isClone) {
          this.removeNewExercise();
        } else if (this.isBaseMode(this.exercise)) {
          const cloneQuizze = this.exercises.filter(item => item.id === this.exercise.id
            && item.code === 'CHXZ' && item.mode === 4);
          this.newExercises.push(utils.clone(this.exercise));
          this.newExercises.splice(0, 1);
          if (cloneQuizze.length) {
            this.newExercises.push({ ...cloneQuizze[0], showCount: 0, isClone: true });
          }
        } else {
          this.backwardsInsertExercise();
        }
      }
    },
    // 错题重练 向后插入
    backwardsInsertExercise(exercise, index = 1) {
      const [first, ...others] = this.newExercises;
      if (this.newExercises.length >= 2) {
        this.newExercises = others;
        this.newExercises.splice(index, 0, exercise || first);
      } else {
        const last = Object.assign({}, this.newExercises[0]);
        this.newExercises = [last];
      }
    },
    pushResults() {
      /* eslint-disable */
      const resultsIndex = utils.Array.findIndex(this.results, this.exercise, 'id');
      if (resultsIndex !== -1) {
        const result = this.results[resultsIndex];
        result.errorCount = this.isRight ? result.errorCount : result.errorCount + 1;
        if (this.quizType !== 'student_wrong') {
          result.status = result.errorCount >= 2 ? 0 : 1;
        }
      } else {
        this.results.push({
          id: this.exercise.id,
          status: this.exercise.errorCount ? 0 : 1,
          answer: '',
          errorCount: this.exercise.errorCount,
        });
      }

      // 处理错词本单词拼写游戏
      if (this.quizType === 'student_wrong'
        && (this.exercise.code === 'DCPX' || (this.exercise.code === 'CHXZ'
        && this.exercise.mode === 4))
        && this.exercise.showCount === 1 && this.isRight) {
          utils.Array.find(this.results, this.exercise, 'id').status = 1;
      }
      this.handleTimes(this.exercise, this.seconds);

      if (this.results.length === 20
        && this.exercises.length >= 50
        && this.quizType === 'active_review') {
        this.$emit('finish', {
          results: this.results,
          spend: this.spend,
          isHalf: true,
        });
        setTimeout(() => {
          this.$refs.countdown.stop();
        }, 0);
      }
    },
    removeNewExercise() {
      if (this.newExercises.length === 1) {
        this.newExercises = [];
      } else {
        const [, ...others] = this.newExercises;
        this.newExercises = [...others];
      }
    },
    isBaseMode({ mode, code }) {
      return this.bookMode === 'basic'
            && (code === 'CHXZ'
            && (mode === 1 || mode === 2))
    },
    prev() {
      if (this.exerciseIndex <= 0) {
        utils.message('已经是第一题了', 'warning');
        return;
      }
      this.exerciseIndex -= 1;
    },
    next() {
      if (this.isExam) {
        if (this.exerciseIndex >= this.newExercises.length - 1) {
          utils.message('已经是最后一题了', 'warning');
          return;
        } else {
          this.exerciseIndex += 1;
        }
      } else {
        if (this.isDirectlyDone) {
          this.isDone = true;
        }
        if (this.isDone) {
          if (!this.isRight && !this.exercise.code === 'CHXZ' ) {
            this.$refs.countdown.stop();
          }
          if (this.isPlayed) {
            this.correctExercise();
            this.isDone = false;
          }
        } else {
          this.isDone = true;
        }
      }
    },
    submit() {
      const isOnce = this.quizType === 'online' || this.quizType === 'unit_dictation';
      this.examResults.forEach((item, index) => {
        const resultsIndex = utils.Array.findIndex(this.results, item, 'id');
        this.handleTimes(this.examSpend[index], this.examSpend[index].spendTime);
        if (resultsIndex !== -1) {
          if (!item.isRight) {
            this.results[resultsIndex].errorCount += 1;
          } else {
            this.results[resultsIndex].status = this.results[resultsIndex].errorCount <= 0 ? 1 : 0;
          }
        } else {
          this.results.push({
            id: item.id,
            errorCount: item.isRight ? 0 : 1,
            status: item.isRight && isOnce ? 1 : 0,
            answer: '',
          });
        }
      });
      this.$emit('submit', {
        results: this.results,
        spend: this.spend,
      });
    },
    handleTimes(obj, second) {
      let spendIndex = -1;
      for (let i = 0; i < this.spend.length; i++) {
        const item = this.spend[i];
        if (item && obj && obj.code === item.code && obj.mode === item.mode) {
          spendIndex = i;
          break;
        }
      }
      if (spendIndex !== -1) {
        this.spend[spendIndex].spendTime += second;
      } else if (spendIndex === -1 && obj !== undefined){
        this.spend.push({
          code: obj.code,
          mode: obj.mode,
          spendTime: second,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .component-wrap {
    height: 100%;
    background: #fff;
    border-radius: 24px;
    color: #333;
    .countdown-wrap {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 64px;
      height: 64px;
      /deep/ .countdown {
        width: 64px;
        height: 64px;
        .seconds {
          font-size: 28px!important;
          line-height: 64px;
        }
      }
    }
    /deep/ .hint {
      font-size: 16px;
    }
    /deep/ .control-bar-u {
      padding: 10px 20px;
      border-radius: 0 0 30px 30px;
    }
  }
</style>
